import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";
import { useNavigate } from "react-router-dom";

const AdminHotspot = () => {
    const navigate =
        useNavigate();

    const [rooms, setRooms] =
        useState([]);

    const [sceneId, setSceneId] =
        useState("");

    const [targetId, setTargetId] =
        useState("");

    const [yaw, setYaw] =
        useState("");

    const [pitch, setPitch] =
        useState("");

    const [direction, setDirection] =
        useState("right");

    const [activeRoom, setActiveRoom] =
        useState(null);

    useEffect(() => {
        fetchRooms();
    }, []);

    const fetchRooms =
        async () => {
            try {
                const res =
                    await axios.get(
                        "https://kasiaweb.ilakshyaerp.in/api/tours"
                    );

                setRooms(
                    Array.isArray(
                        res.data
                    )
                        ? res.data
                        : []
                );
            } catch {
                setRooms([]);
            }
        };

    useEffect(() => {
        const room =
            rooms.find(
                (r) =>
                    Number(
                        r.id
                    ) ===
                    Number(
                        sceneId
                    )
            );

        setActiveRoom(room);
    }, [
        sceneId,
        rooms
    ]);

    const handleImageClick =
        (e) => {
            const rect =
                e.target.getBoundingClientRect();

            const x =
                ((e.clientX -
                    rect.left) /
                    rect.width) *
                100;

            const y =
                ((e.clientY -
                    rect.top) /
                    rect.height) *
                100;

            setYaw(
                x.toFixed(2)
            );

            setPitch(
                y.toFixed(2)
            );
        };

    const submit =
        async () => {
            try {
                await axios.post(
                    "https://kasiaweb.ilakshyaerp.in/api/hotspots/add",
                    {
                        scene_id:
                            sceneId,
                        target_scene_id:
                            targetId,
                        yaw,
                        pitch,
                        direction,
                    }
                );

                alert(
                    "Hotspot Added"
                );

                setYaw("");
                setPitch("");
            } catch {
                alert(
                    "Save Failed"
                );
            }
        };

    const getArrow =
        () => {
            if (
                direction ===
                "left"
            )
                return "←";

            if (
                direction ===
                "up"
            )
                return "↑";

            if (
                direction ===
                "down"
            )
                return "↓";

            return "→";
        };

    const isMobile = window.innerWidth <= 768;

    return (
        <div
            style={{
                minHeight:
                    "100vh",
                background:
                    "#eef2f7",
                padding: isMobile ? "10px" : "35px",
                position:
                    "relative",
                fontFamily:
                    "Arial",
            }}
        >
            {/* EXIT */}
            <button
                onClick={() =>
                    navigate(
                        "/admin/admin-tour"
                    )
                }
                style={{
                    position:
                        "absolute",
                    top: isMobile ? "10px" : "28px",
                    right: isMobile ? "10px" : "28px",
                    width: isMobile ? "38px" : "48px",
                    height: isMobile ? "38px" : "48px",
                    borderRadius:
                        "50%",
                    border:
                        "none",
                    background:
                        "#ff1f1f",
                    color:
                        "#fff",
                    fontSize:
                        "26px",
                    cursor:
                        "pointer",
                    fontWeight:
                        "bold",
                }}
            >
                ×
            </button>

            {/* TITLE */}
            <h1
                style={{
                    textAlign:
                        "center",
                    fontSize: isMobile ? "28px" : "56px",
                    fontWeight:
                        "800",
                    color:
                        "#16315f",
                    marginBottom: isMobile ? "15px" : "35px",
                }}
            >
                Admin Hotspot
            </h1>

            {/* MAIN GRID */}
            <div
                style={{
                    display:
                        "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "400px 1fr",
                    gap: isMobile ? "15px" : "32px",
                    alignItems:
                        "stretch",
                }}
            >
                {/* LEFT PANEL */}
                <div
                    style={{
                        background:
                            "#fff",
                        borderRadius: isMobile ? "15px" : "28px",
                        padding: isMobile ? "15px" : "26px",
                        boxShadow:
                            "0 10px 30px rgba(0,0,0,.08)",
                    }}
                >
                    <select
                        value={
                            sceneId
                        }
                        onChange={(
                            e
                        ) =>
                            setSceneId(
                                e.target
                                    .value
                            )
                        }
                        style={{
                            width:
                                "100%",
                            padding:
                                "16px",
                            borderRadius:
                                "14px",
                            marginBottom:
                                "18px",
                            border:
                                "1px solid #ddd",
                            fontSize:
                                "16px",
                        }}
                    >
                        <option value="">
                            Select Current Room
                        </option>

                        {rooms.map(
                            (
                                room
                            ) => (
                                <option
                                    key={
                                        room.id
                                    }
                                    value={
                                        room.id
                                    }
                                >
                                    {
                                        room.title
                                    }
                                </option>
                            )
                        )}
                    </select>

                    <select
                        value={
                            targetId
                        }
                        onChange={(
                            e
                        ) =>
                            setTargetId(
                                e.target
                                    .value
                            )
                        }
                        style={{
                            width:
                                "100%",
                            padding:
                                "16px",
                            borderRadius:
                                "14px",
                            marginBottom:
                                "18px",
                            border:
                                "1px solid #ddd",
                            fontSize:
                                "16px",
                        }}
                    >
                        <option value="">
                            Select Target Room
                        </option>

                        {rooms.map(
                            (
                                room
                            ) => (
                                <option
                                    key={
                                        room.id
                                    }
                                    value={
                                        room.id
                                    }
                                >
                                    {
                                        room.title
                                    }
                                </option>
                            )
                        )}
                    </select>

                    <input
                        value={yaw}
                        readOnly
                        placeholder="Yaw"
                        style={{
                            width: "100%",
                            padding: "16px",
                            borderRadius: "14px",
                            marginBottom: "18px",
                            border: "1px solid #ddd",
                            fontSize: "16px",
                            boxSizing: "border-box"
                        }}
                    />

                    <input
                        value={pitch}
                        readOnly
                        placeholder="Pitch"
                        style={{
                            width: "100%",
                            padding: "16px",
                            borderRadius: "14px",
                            marginBottom: "22px",
                            border: "1px solid #ddd",
                            fontSize: "16px",
                            boxSizing: "border-box"
                        }}
                    />

                    <h3
                        style={{
                            color:
                                "#16315f",
                            marginBottom:
                                "16px",
                        }}
                    >
                        Select Direction
                    </h3>

                    <div
                        style={{
                            display:
                                "grid",
                            gridTemplateColumns:
                                "1fr 1fr",
                            gap: "14px",
                        }}
                    >
                        {[
                            [
                                "up",
                                "↑",
                            ],
                            [
                                "left",
                                "←",
                            ],
                            [
                                "right",
                                "→",
                            ],
                            [
                                "down",
                                "↓",
                            ],
                        ].map(
                            (
                                item
                            ) => (
                                <button
                                    key={
                                        item[0]
                                    }
                                    onClick={() =>
                                        setDirection(
                                            item[0]
                                        )
                                    }
                                    style={{
                                        adding: isMobile ? "12px" : "20px",
                                        border:
                                            "none",
                                        borderRadius:
                                            "16px",
                                        background:
                                            direction ===
                                                item[0]
                                                ? "#24428b"
                                                : "#d8dee8",
                                        color:
                                            direction ===
                                                item[0]
                                                ? "#fff"
                                                : "#111",
                                        fontSize: isMobile ? "24px" : "34px",
                                        cursor:
                                            "pointer",
                                    }}
                                >
                                    {
                                        item[1]
                                    }
                                </button>
                            )
                        )}
                    </div>

                    <button
                        onClick={
                            submit
                        }
                        style={{
                            width:
                                "100%",
                            marginTop:
                                "18px",
                            padding:
                                "16px",
                            border:
                                "none",
                            borderRadius:
                                "14px",
                            background:
                                "#24428b",
                            color:
                                "#fff",
                            fontSize:
                                "18px",
                            cursor:
                                "pointer",
                            fontWeight:
                                "600",
                        }}
                    >
                        Save Hotspot
                    </button>
                </div>

                {/* RIGHT PANEL */}
                <div
                    style={{
                        background:
                            "#fff",
                        borderRadius:
                            "28px",
                        boxShadow:
                            "0 10px 30px rgba(0,0,0,.08)",
                        minHeight: isMobile ? "300px" : "720px",
                        padding: isMobile ? "10px" : "20px",
                        display:
                            "flex",
                        justifyContent:
                            "center",
                        alignItems:
                            "center",
                        position:
                            "relative",
                        overflow:
                            "hidden",
                    }}
                >
                    {activeRoom ? (
                        <div
                            style={{
                                width:
                                    "100%",
                                height:
                                    "100%",
                                position:
                                    "relative",
                            }}
                        >
                            <img
                                src={`https://kasiaweb.ilakshyaerp.in/uploads/virtual-image/${activeRoom.image}`}
                                onClick={
                                    handleImageClick
                                }
                                alt=""
                                style={{
                                    width:
                                        "100%",
                                    height: isMobile ? "250px" : "680px",
                                    objectFit:
                                        "cover",
                                    borderRadius:
                                        "22px",
                                    cursor:
                                        "crosshair",
                                }}
                            />

                            {yaw &&
                                pitch && (
                                    <div
                                        style={{
                                            position:
                                                "absolute",
                                            left: `${yaw}%`,
                                            top: `${pitch}%`,
                                            transform:
                                                "translate(-50%,-50%)",
                                            width: isMobile ? "40px" : "58px",
                                            height: isMobile ? "40px" : "58px",
                                            fontSize: isMobile ? "22px" : "32px",
                                            borderRadius:
                                                "50%",
                                            background:
                                                "#fff",
                                            display:
                                                "flex",
                                            justifyContent:
                                                "center",
                                            alignItems:
                                                "center",
                                            boxShadow:
                                                "0 5px 15px rgba(0,0,0,.2)",
                                        }}
                                    >
                                        {getArrow()}
                                    </div>
                                )}
                        </div>
                    ) : (
                        <h2
                            style={{
                                color:
                                    "#8da0c0",
                                fontSize:
                                    "42px",
                                fontWeight:
                                    "400",
                            }}
                        >
                            Select room first
                        </h2>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminHotspot;